import clippath from '../../assets/images/ClipGroup.png';
export default function BottomSection() {
    return(
        <>
            <div className="w-full  -mt-16  lg:-mt-[220px] overflow-hidden" >
                <img src={clippath} alt="" className='md:w-full md:block hidden w-[250%]' />
                <img src="/footer-small.png" alt="" className='md:hidden mt-5' />
            </div>
        </>

    );

}